import { SourceProp } from "./props.type";

export const sourceTypeGenerator = (data : SourceProp) => {
    
    [
        {
            src: data.avif ? data.avif : '',
            type: 'image/avif',
        },
        {
            src: data.png,
            type: 'image/png',
        },
        {
            src: data.webp,
            type: 'image/webp',
        },
    ]
}